<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CẬP NHẬP THÔNG TIN LIÊN LẠC</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field label="Họ tên" v-model="contact.buyerName" outlined hide-details></v-text-field>
          <v-text-field
            label="Số điện thoại"
            required
            type="tel"
            v-model="contact.phone"
            outlined
            :rules="[$rules.required, $rules.phone]"
            class="pt-6"
          ></v-text-field>
          <v-text-field
            label="Email"
            type="email"
            v-model="contact.email"
            outlined
            :rules="[$rules.email]"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props: {
    state: Boolean,
    profile: Object
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.setFormValues(newProfile)
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      contact: {
        buyerName: '',
        phone: '',
        email: ''
      }
    }
  },
  methods: {
    ...mapActions('lead', ['updateLead']),

    close() {
      this.$emit('closeDialog')
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        let lead = {...this.contact}
        const updatedLead = await this.updateLead({id: this.profile.id, ...lead})
        if (updatedLead) {
          this.$emit('refresh')
          this.close()
        }
      }
    },
    setFormValues(profile) {
      this.contact.buyerName = profile.buyerName || ''
      this.contact.phone = profile.phone || ''
      this.contact.email = profile.email || ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
